// extracted by mini-css-extract-plugin
export default {"hiddenInput":"styles_hiddenInput__wFuox"};